import React, {useContext} from 'react';
// import DropdownOrder from './DropdownOrder';
import {APP} from '../Utils/Constants.ts';
import {FiltersContext} from "../Context/FiltersContext.tsx";

interface SortProps {
  value: any;
  handlerOrder: (filterId: string, values: any) => void;
}

interface Translations {
  [key: string]: string; // Signature d'index pour des clés dynamiques
}


const Sort: React.FC<SortProps> = ({handlerOrder, value}) => {
  const {filters} = useContext(FiltersContext);

  const getTranslationsKey = () => {
    if (filters.some(param => param.id === APP.FILTER.SEARCH.FIELD) && !value) {
      return 'SCORE_DESC';
    }
    if (!value) {
      return 'NAME_ASC'
    }
    if (!value.values.direction) {
      const values = value.values.split(" ");
      const translationKey: Translations = {
        score: "SCORE",
        ss_product_title: "NAME",
        its_field_formation_duration_liste: "DURATION",
        itm_variation_prices: "PRICE",
        dm_variation_dates: "DATE_START"
      }
      return translationKey[values[0]] + "_" + values[1].toUpperCase()
    }
    return value.values.key + "_" + value.values.direction.toUpperCase()
  }

  let translations: Translations = {
    SCORE_DESC: Drupal.t('Pertinence'),
    NAME_ASC: Drupal.t('A > Z'),
    NAME_DESC: Drupal.t('Z > A'),
    DURATION_ASC: Drupal.t('Durée croissante'),
    DURATION_DESC: Drupal.t('Durée décroissante'),
    PRICE_ASC: Drupal.t('Prix croissants'),
    PRICE_DESC: Drupal.t('Prix décroissants'),
    DATE_START_DESC: Drupal.t('Plus anciens en premiers'),
    DATE_START_ASC: Drupal.t('Plus récents en premiers'),
  };
  let options: { name: string; option: { key: string; id: string; field: string; direction: string; }; }[] = [];
  let currentTitle = translations[getTranslationsKey()]; // Utiliser une clé spécifique

  Object.keys(APP.ORDER).forEach((orderKey) => {
    Object.keys(APP.ORDER_DIRECTION).forEach((orderDirectionKey) => {

      let translationKey = `${orderKey}_${orderDirectionKey}`;

      if (translations[translationKey]) {

        options.push({
          name: translations[translationKey],
          option: {
            key: orderKey,
            id: APP.ORDER[orderKey].NAME,
            field: APP.ORDER[orderKey].FIELD,
            direction: APP.ORDER_DIRECTION[orderDirectionKey]
          }
        });
      }
    });
  });

  return (
    <div className="sort__wrapper">
      <label htmlFor="sort-select">{Drupal.t('Trier par :')}</label>
      <select
        id="sort-select"
        className="sort-select"
        onChange={(e) => {
          const selectedOption = options.find(option => option.name === e.target.value);
          if (selectedOption) {
            handlerOrder("sort", selectedOption.option);
          }
        }}
        value={currentTitle}
      >
        {options.map((option) => {
          return (<option key={option.option.id + '_' + option.option.direction} value={option.name}
                          selected={currentTitle === option.name}>
            {option.name}
          </option>)
        })}
      </select>
    </div>
  );

};

export default Sort;
